import { UseMutationResult } from "@tanstack/react-query";
import { downloadBlob } from "components/Utils/actions";
import dayjs, { Dayjs } from "dayjs";

export const useDownloadReport = (
  mutationFn: (options: any) => UseMutationResult<any>,
  reportName: string,
  startDate: Dayjs,
  endDate: Dayjs
) => {
  return mutationFn({
    onSuccess: (data) =>
      downloadBlob(
        (data as unknown as { blob: Blob }).blob,
        `${reportName}_${dayjs(startDate).format("DD_MM_YY")}-${dayjs(endDate).format("DD_MM_YY")}.xlsx`
      ),
  });
};
